import { useCallback, useEffect, useState } from "react";

// material ui components
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { checkUserBank } from "../../../../setup/api/services/payment";

// styles
import styles from "./styles.module.css";
import EmptyBankInfo from "./EmptyBankInfo";
import BankInfo from "./BankInfo";

const UserBankInfoModal = (props: any) => {
  const { showModal, closeModal, userId } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [response, setRespons] = useState<any>(null);

  useEffect(() => {
    userId &&
      showModal &&
      fetchBankInfo(userId)
        .then((res) => {
          if (res) {
            setRespons(res.data);
          } else {
            setRespons(null);
          }
        })
        .catch();
  }, [userId, showModal]);

  const fetchBankInfo = useCallback(async (userId) => {
    setLoading(true);
    try {
      const respons = await checkUserBank(userId);
      setLoading(false);
      return respons;
    } catch (error) {
      console.error;
      setLoading(false);
    }
  }, []);

  return (
    <Modal
      open={showModal}
      onClose={(_, reason) => {
        closeModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box className={styles["container_wrapper"]}>
        <IconButton aria-label="close" onClick={closeModal}>
          <CloseIcon />
        </IconButton>
        {loading ? (
          <Box className="center">
            <CircularProgress />
          </Box>
        ) : (
          <>{response ? <BankInfo data={response} /> : <EmptyBankInfo />}</>
        )}
      </Box>
    </Modal>
  );
};

export default UserBankInfoModal;
